// extracted by mini-css-extract-plugin
module.exports = {"hrProtfolio":"MasterPortfolio_hrProtfolio__4_K0_","h3Protfolio":"MasterPortfolio_h3Protfolio__2ab6T"};